export const ENV = () => {
    return {
        BASE_URL_GL: 'https://gateway.bitazzax.com/api',
        BASE_URL_TH: 'https://gateway.bitazza.co.th/api',
        ICON_URL_GL: 'https://assets.bitazzax.com/icons',
        ICON_URL_TH: 'https://assets.bitazza.co.th/icons',
    }
}
